import { render, staticRenderFns } from "./TariffsBanner.vue?vue&type=template&id=cf33e42c&scoped=true"
import script from "./TariffsBanner.vue?vue&type=script&lang=js"
export * from "./TariffsBanner.vue?vue&type=script&lang=js"
import style0 from "./TariffsBanner.vue?vue&type=style&index=0&id=cf33e42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf33e42c",
  null
  
)

export default component.exports